import { Label } from '@/components/ui/label';
import { DialogForm } from '@/features/dialog/dialog-form';
import { RichTextInput } from '@/features/rich-text/components/rich-text-input';
import { useLocale } from '@/lib/hooks/use-locale';
import type { CrmTaskInputDTO } from '@/server/dto/crm-task-input-dto';
import type { UseFormReturn } from 'react-hook-form';
import { Controller } from 'react-hook-form';

type TaskDescriptionFieldProps = {
    form: UseFormReturn<CrmTaskInputDTO>;
    className?: string;
};

export const TaskDescriptionField = ({ form, className }: TaskDescriptionFieldProps) => {
    const { t } = useLocale('tasks');

    const {
        control,
        formState: { errors: formErrors },
    } = form;

    return (
        <DialogForm.Item className={className}>
            <Label htmlFor="description" className="sr-only">
                {t('description')}
            </Label>
            <DialogForm.Body>
                <Controller
                    name="description"
                    control={control}
                    render={({ field }) => (
                        <RichTextInput
                            entityType="task"
                            placeholder={t('tasks__description_placeholder')}
                            {...field}
                        />
                    )}
                />
            </DialogForm.Body>
            <DialogForm.Error error={formErrors.description} />
        </DialogForm.Item>
    );
};
